import { Stack } from "@mui/system";
import { EVALUE } from "../helpers/consts";
import CTextField from "./Common/CTextField";
import MinMaxField from "./MinMaxField";
import CDateTimePicker from "./TriggerTime/CDateTimePicker";

type PFieldContent = {
    field: string;
    onUpdate: any;
    min: any;
    max: any;
};

export function FieldContentText(props: PFieldContent) {
    return (<>
        <Stack direction={{sm:"row"}} justifyContent="space-between" alignItems={{xs:"left",sm:'center'}}>
            <Stack direction={{md:'row'}} spacing={5} m={1}>
                <CTextField field={props.field} evalue={EVALUE.MIN} enabled={false} onChange={props.onUpdate}></CTextField>
                <CTextField field={props.field} evalue={EVALUE.MAX} enabled={false} onChange={props.onUpdate}></CTextField>
            </Stack>
            <MinMaxField min={props.min} max={props.max}></MinMaxField>
        </Stack>
        </>
    );
}

export function FieldContentDate(props: PFieldContent) {
    return (
        <Stack direction={{sm:"row"}} justifyContent="space-between" alignItems={{sx:"left",sm:'center'}}>
            <Stack direction={{md:"row"}} spacing={5} m={1}>
                <CDateTimePicker field={props.field} evalue={EVALUE.MIN} enabled={false} onChange={props.onUpdate}></CDateTimePicker>
                <CDateTimePicker field={props.field} evalue={EVALUE.MAX} enabled={false} onChange={props.onUpdate}></CDateTimePicker>
            </Stack>
            <MinMaxField min={props.min} max={props.max}></MinMaxField>
        </Stack>
    );
}
